import {createSlice} from "@reduxjs/toolkit";

const blogSlice = createSlice({
    name: 'blog',
    initialState: {
        posts: [],
        post: {
            content:'',
            title:'',
            description: '',
        },
    },
    reducers: {
        setPosts: (state, action) => {
            state.posts = action.payload;
        },
        setPost: (state, action) => {
            state.post = action.payload;
        },
    }
})

export const {
    setPosts,
    setPost
} = blogSlice.actions

export const getPosts = (state) => state.blogs.posts;
export const getPost = (state) => state.blogs.post;

export default blogSlice.reducer;